import React from "react";
import {
  Box,
  Flex,
  Heading,
  Image,
  Text,
  useColorModeValue,
  type BoxProps,
} from "@chakra-ui/react";

// Imported as a URL (not the svgr `?r` component) so the badge renders as an
// isolated <img>. The inlined svgr version collides with other gradient icons
// on the page: svgo minifies each icon's gradient id to "a"/"b"/… with no
// per-file prefix, so this badge's `url(#a)` fill resolves to another icon's
// definition and renders blank.
import guaranteeBadge from "@/assets/icons/icono-garantia-vrd.svg?url";

type GuaranteeBoxProps = {
  title: string;
  description: string;
} & BoxProps;

export const GuaranteeBox: React.FC<GuaranteeBoxProps> = ({
  title,
  description,
  ...boxProps
}) => {
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.300");
  const bg = useColorModeValue("white", "whiteAlpha.50");
  const titleColor = useColorModeValue("gray.800", "gray.100");
  const descColor = useColorModeValue("gray.600", "gray.300");

  return (
    <Box
      id="promo-bono-bootcamp"
      bg={bg}
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="6px"
      p={{ base: 4, md: 5 }}
      {...boxProps}
    >
      <Flex align="center" gap={{ base: 3, md: 4 }}>
        <Box flex="0 0 auto" display="flex" alignItems="center">
          <Image src={guaranteeBadge} alt="" w="80px" h="80px" flexShrink={0} />
        </Box>

        <Box minW={0}>
          <Heading
            as="h3"
            color={titleColor}
            fontFamily="Poppins"
            fontWeight="600"
            fontSize="16px"
          >
            {title}
          </Heading>
          <Text fontSize="14px" color={descColor}>
            {description}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};
